import { Card, FormHelperText } from "@mui/material";

interface Props {
  children: React.ReactNode;
  error?: boolean; // エラーがtrueの時は枠を赤く表示する
  helperText?: string; // エラーがtrueのときに表示する文字列
}
export const SectionPaper: React.FC<Props> = ({
  children,
  error,
  helperText,
}) => {
  return (
    <>
      <Card
        variant="outlined"
        sx={error ? { border: "1px solid red" } : undefined}
      >
        {children}
      </Card>
      <FormHelperText error sx={{ ml: "1em" }}>
        {helperText ?? ""}
      </FormHelperText>
    </>
  );
};
